import axios from 'axios'

class Base {
  /**
   * 获取数据
   * @param url
   * @param params
   * @param cacheKey.是否缓存数据, 以ss_ 存在ssessionStorage中，以ls_开头存在localStorage中,以v_开头存在 vux状态cache对象中
   * @param force 强制刷新数据
   * @returns {*}
   */
  static get(url, params, config = {}) {
    // //取缓存值
    // if (config && config.cacheKey && config.force !== true) {
    //   let data = this.cache(config.cacheKey)
    //   if (data) {
    //     return Promise.resolve({code: '0', data})
    //   }
    // }
    // let p = Object.assign({params}, config)
    // return axios.get(url, p).then(res => {
    //   if (config && config.cacheKey) { //设置缓存值
    //     this.cache(config.cacheKey, res.code == '0' ? res.data : null)
    //   }
    //   // return Promise.resolve(res)
    //   // 匹配H5 axios 数据返回格式
    //   return Promise.resolve(res.data)
    // }).catch(res => {
    //   console.error(res)
    //   return Promise.resolve({
    //     code: '-404',
    //     msg: '网络异常'
    //   })
    // })
    if (config) config.withCredentials = true
    return window.$httpUtil.instance.get(url, params, config)
  }

  static post(url, data, config = {}) {
    // return axios.post(url, data, config).then(res => {
    //   return Promise.resolve(res.data || {})
    // }).catch(() => {
    //   return Promise.resolve({
    //     code: '-404',
    //     msg: '网络异常'
    //   })
    // })
    if (config) config.withCredentials = true
    return window.$httpUtil.instance.post(url, data, config)
  }

  //缓存数据
  static cache(name, value) {
    let obj = name.startsWith('ls_') ? $tool.ls : $tool.ss
    if (value) {
      obj.setItem(name, value)
    } else if (value === null) {
      obj.removeItem(name)
    } else {
      return obj.getItem(name)
    }
  }

  //清除缓存
  static deleteCache(name) {
    sessionStorage.removeItem('dd_corpId')
    let obj = name.startsWith('ls_') ? $tool.ls : $tool.ss
    obj.removeItem(name)
  }
}

export default Base
